<template>
  <div>
    <div id="content">
      <el-row>
        <el-col :span="12"
          ><div class="dleft">
            <div class="anl">
              <el-input
                v-model="keyword"
                placeholder="QuestionID"
                clearable
                size="small"
                style="width: 184px; margin-right: 115px"
              ></el-input>
              <el-button type="info" plain size="small" @click="selectAll"
                ><i class="el-icon-check"></i>全选</el-button
              ><el-button type="info" plain size="small" @click="valueQid = []"
                ><i class="el-icon-close"></i>全不选</el-button
              ><el-button
                size="small"
                type="primary"
                @click="add"
                :loading="loading"
                ><i class="el-icon-plus"></i>添加</el-button
              >
            </div>
            <div>
              <el-cascader-panel
              ref="cascaderPanel" 
                v-model="valueQid"
                :options="optionsFil"
                :props="{ multiple: true, emitPath: false }"
              ></el-cascader-panel>
            </div>
            <div class="weizhi" v-if="weiShow">
                  <p>multi 类型需要选取匹配的题型</p>
                  <el-radio-group v-model="wei">
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('1')" @click="showImage('1')" alt="Option 1示意图">
                      </span>
                      <el-radio label="1" border>
                        适用于：品牌带入题干，single、grid有无loop均可
                      </el-radio>
                    </div>
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('2')" @click="showImage('2')" alt="Option 2示意图">
                      </span>
                      <el-radio label="2" border>
                        适用于：Questionid相同带loop，loop句子
                      </el-radio>
                    </div>
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('3')" @click="showImage('3')" alt="Option 3示意图">
                      </span>
                      <el-radio label="3" border>
                        适用于：Questionid相同带loop，loop品牌
                      </el-radio>
                    </div>
                    <div class="radio-with-image">
                      <span class="thumbnail-container">
                        <img class="thumbnail" :src="getThumbnail('4')" @click="showImage('4')" alt="Option 4示意图">
                      </span>
                      <el-radio label="4" border>
                        适用于：QuestionId不同，句子选品牌
                      </el-radio>
                    </div>
                  </el-radio-group>
                  
                  <!-- 图片预览对话框 -->
                  <el-dialog
                    :visible.sync="imageDialogVisible"
                    :modal-append-to-body="true"
                    width="70%"
                    top="5vh"
                    center
                    custom-class="image-preview-dialog"
                  >
                    <div style="text-align: center;">
                      <img :src="currentImage" style="width: 100%; height: auto; max-height: 70vh; object-fit: contain;" />
                    </div>
                  </el-dialog>
            </div>
            </div
        ></el-col>
        <el-col :span="12"
          ><div class="dright" v-show="configs.length > 0">
            <div class="anl">
              <span style="font-size: 13px; color: #afafaf"
                >已创建组合表格，共 {{ configs.length }} 个</span
              >
              <el-button
                type="danger"
                plain
                size="mini"
                round
                style="margin-left: 16px"
                :loading="clearLoading"
                @click="clearAll"
              ><i class="el-icon-delete"></i>清除</el-button>
            </div>
            <el-table
              :data="configs"
              style="width: 100%; margin-top: 20px"
              stripe
              border
              size="mini"
            >
              <el-table-column
                prop="qid"
                label="组合ID"
                width="200"
              ></el-table-column>
              <el-table-column
                prop="tpe"
                label="题型"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="wei"
                label="类型"
                width="120"
              ></el-table-column>
              <el-table-column label="操作" width="180">
                <template #default="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    plain
                    round
                    @click="preview(scope.row, scope.$index)"
                    ><i class="el-icon-view"></i>预览</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    plain
                    round
                    @click="tagDel(scope.$index, scope.row.id)"
                    ><i class="el-icon-delete"></i>删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div></el-col
        >
      </el-row>
    </div>

    <!-- 预览弹窗 -->
    <el-dialog
      custom-class="zuhe-preview-dialog"
      :visible.sync="previewDialogVisible"
      width="92%"
      top="2vh"
      :modal-append-to-body="true"
      :before-close="handlePreviewClose"
      @mousedown.native="cancelEdit"
    >
      <template slot="title">
        <div class="dlg-title-bar">
          <span class="dlg-title">组合表预览</span>
          <el-tag v-if="previewRow" size="mini" effect="plain">{{ previewRow.qid }}</el-tag>
          <el-tag v-if="previewRow" size="mini" type="info" effect="plain">{{ previewTpe }}</el-tag>
          <span class="dlg-stats" v-if="previewGroups.length">{{ previewStats }}</span>
        </div>
      </template>

      <!-- 工具栏：品牌匹配（仅loop型grid显示，选择非loop的single/multi题，loop号↔选项code对应） -->
      <div class="preview-toolbar" v-if="isLoopGrid && previewGroups.length > 0">
        <div class="tb-left">
          <span class="brand-label">品牌匹配</span>
          <el-select
            v-model="brandQid"
            filterable
            clearable
            size="small"
            placeholder="选择品牌题(single/multi)"
            :loading="brandLoading"
            @change="onBrandChange"
            style="width: 220px"
          >
            <el-option v-for="q in brandOptions" :key="q" :value="q" :label="q"></el-option>
          </el-select>
          <el-tooltip content="loop号 ↔ 选项code 匹配，选中后选项文本(品牌名)将显示在各loop标题及下载数据表中" placement="bottom">
            <i class="el-icon-question tb-help"></i>
          </el-tooltip>
        </div>
      </div>
      <!-- loop 快速导航（grid多loop时显示，点击跳转） -->
      <div class="loop-quicknav" v-if="previewTpe === 'grid' && previewGroups.length > 1">
        <div
          v-for="(g, gi) in previewGroups"
          :key="'qn-'+gi"
          class="qn-chip"
          :class="{ active: activeGi === gi }"
          @click="scrollToGroup(gi)"
        >{{ quickChipText(g) }}</div>
      </div>
      <div class="preview-table-wrap" ref="previewWrap" @scroll="onWrapScroll" v-if="previewGroups.length > 0">
        <div class="preview-table-center">
          <div v-for="(g, gi) in previewGroups" :key="'group-'+gi" class="preview-group" ref="previewGroupEl">
            <div v-if="previewTpe === 'grid'" class="group-title">loop {{ g.lph === '' ? '(无loop标识)' : g.lph }}{{ loopBrandText(g.lph) }}</div>
            <table class="preview-table" cellspacing="0" cellpadding="0">
              <thead>
                <tr :ref="'headerLabelRow'">
                  <th class="side-header" rowspan="2">Label</th>
                  <th class="side-header" rowspan="2">Code</th>
                  <th v-for="(h, i) in g.heads" :key="'label-'+gi+'-'+i"
                    class="data-col drag-col"
                    :title="h.Label"
                    :style="{ minWidth: isEditingHead(gi, i) ? '200px' : '' }">
                    <div class="col-header-inner" :style="{ minWidth: isEditingHead(gi, i) ? '200px' : '' }">
                      <i class="el-icon-rank drag-handle" title="拖拽排序"></i>
                      <el-input
                        v-if="isEditingHead(gi, i)"
                        v-model="h.Label"
                        size="mini"
                        @blur="endEditHead(gi, i)"
                        @keyup.enter="endEditHead(gi, i)"
                        @mousedown.native.stop
                        :ref="'headInput' + gi + '-' + i"
                        autofocus
                      ></el-input>
                      <span v-else class="col-content" @click="startEditHead(gi, i)">{{ h.Label }}</span>
                      <i v-if="!isEditingHead(gi, i)" class="el-icon-edit edit-ico" title="点击文本可编辑"></i>
                    </div>
                    <i class="el-icon-close col-del" @click.stop="delCol(gi, i)" title="删除此列"></i>
                  </th>
                </tr>
                <tr>
                  <th v-for="(h, i) in g.heads" :key="'code-'+gi+'-'+i" class="data-col code-row" :title="h.Code">{{ h.Code }}</th>
                </tr>
              </thead>
              <tbody :ref="'previewTbody'">
                <tr v-for="(s, j) in previewSides" :key="'row-'+gi+'-'+j" class="data-row">
                  <td class="side-cell" :style="{ minWidth: isEditingSide(j) ? '200px' : '' }">
                    <div class="row-cell-inner" :style="{ minWidth: isEditingSide(j) ? '200px' : '' }">
                      <i class="el-icon-rank drag-handle" title="拖拽排序"></i>
                      <el-input
                        v-if="isEditingSide(j)"
                        v-model="s.Label"
                        size="mini"
                        @blur="endEditSide(j)"
                        @keyup.enter="endEditSide(j)"
                        @mousedown.native.stop
                        :ref="'sideInput' + j"
                        autofocus
                      ></el-input>
                      <span v-else class="row-label" @click="startEditSide(j)">{{ s.Label }}</span>
                      <i v-if="!isEditingSide(j)" class="el-icon-edit edit-ico" title="点击文本可编辑"></i>
                    </div>
                    <i class="el-icon-close row-del" @click.stop="delRow(j)" title="删除此行"></i>
                  </td>
                  <td class="side-code-cell">{{ s.Code }}</td>
                  <td v-for="(h, i) in g.heads" :key="'cell-'+gi+'-'+j+'-'+i" class="data-col data-cell"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="preview-empty" v-if="previewGroups.length === 0">
        <el-empty description="暂无预览数据，可点击“重置”恢复或关闭后重新预览"></el-empty>
      </div>
      <div slot="footer" class="preview-footer">
        <div class="footer-left">
          <span v-if="isDirty" class="dirty-hint"><i class="el-icon-warning-outline"></i> 有未保存的修改</span>
          <span v-else class="clean-hint">无未保存的修改</span>
        </div>
        <div class="footer-right">
          <el-button size="small" :disabled="!isDirty" @click="resetPreview">重 置</el-button>
          <el-button size="small" @click="handlePreviewClose(() => { previewDialogVisible = false })">取 消</el-button>
          <el-button size="small" type="primary" :loading="saveLoading" :disabled="!isDirty" @click="savePreview">保存修改</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  <script>
import Sortable from 'sortablejs';
export default {
  name: "KpiZuhe",
  props: ["kid", "pid"],
  data() {
    return {
      loading: false,
      clearLoading: false,
      keyword: "",

      valueQid: [],
      configs: [],
      qidcode: {},
      wei:"1",
      weiShow:false,
      options: [],
      optionsFil: [],
      
      // 图片预览相关
      imageDialogVisible: false,
      currentImage: '',

      // 组合表预览相关
      previewDialogVisible: false,
      previewGroups: [],   // [{ lph: 'loop号', heads: [...] }, ...] grid按loop分组；非grid仅一组
      previewTpe: "",
      previewSides: [],    // 表侧所有loop表共用一套
      previewRow: null,
      saveLoading: false,
      rowSortables: [],
      colSortables: [],
      editingHeadKey: "",  // 格式 gi-i，标识正在编辑列的 组-列
      editingSideIndex: -1,

      // grid品牌匹配相关
      brandQid: "",        // 当前关联的品牌题qid
      brandOptions: [],    // 候选品牌题（非loop的single/multi，服务端筛选）
      brandMap: {},        // 选项code → 品牌名
      brandLoading: false,

      // 预览弹窗：脏检测、重置与快速导航
      previewSnapshot: "",   // 打开时的状态快照(JSON)，用于脏检测
      previewInitial: null,  // 打开时的初始数据(deep copy)，用于重置
      activeGi: 0,           // 快速导航当前激活的loop组索引
      scrollTimer: null,     // 滚动节流定时器
    };
  },
  computed: {
    // 是否为loop型grid：存在非空loop号(Lph)的分组；非loop的grid所有列Lph为空、仅单组
    isLoopGrid() {
      return this.previewTpe === "grid" && this.previewGroups.some((g) => g.lph !== "");
    },
    // 标题栏维度统计
    previewStats() {
      if (this.previewGroups.length === 0) return "";
      const loops = this.previewGroups.length;
      const cols = this.previewGroups.reduce((n, g) => n + g.heads.length, 0);
      const rows = this.previewSides.length;
      if (this.isLoopGrid) return loops + " 个loop · " + cols + " 列 · " + rows + " 行";
      return cols + " 列 · " + rows + " 行";
    },
    // 是否有未保存的修改（列/行编辑、删除、排序、品牌匹配关联）
    isDirty() {
      if (!this.previewRow) return false;
      return this.buildSnapshot() !== this.previewSnapshot;
    },
  },
  watch: {
    keyword: {
      handler(val) {
        val = val.toLowerCase();
        this.optionsFil = this.options.filter((p) => {
          return p.label.toLowerCase().indexOf(val) !== -1;
        });
      },
    },
    valueQid(val) {
      if(val.length==0){
        this.wei ="1";
        this.weiShow=false;
        return;
      }
      let qid = val[0];
      if (this.qidcode[qid].Tpe!="multi"){
        return
      }
     this.weiShow=true
     
    },
  },
  methods: {
    startEditHead(gi, index) {
      const key = gi + '-' + index;
      if (this.editingHeadKey !== '' && this.editingHeadKey !== key) {
        this.endEditHeadByKey(this.editingHeadKey);
      }
      this.editingHeadKey = key;
      this.$nextTick(() => {
        const inputs = this.$refs['headInput' + key];
        if (inputs) {
          const inputEl = Array.isArray(inputs) ? inputs[0] : inputs;
          if (inputEl && inputEl.$el) {
            inputEl.$el.querySelector('input').focus();
          }
        }
      });
    },
    endEditHead(gi, index) {
      const key = gi + '-' + index;
      if (this.editingHeadKey === key) {
        this.editingHeadKey = '';
        this.$forceUpdate();
      }
    },
    endEditHeadByKey() {
      this.editingHeadKey = '';
      this.$forceUpdate();
    },
    isEditingHead(gi, index) {
      return this.editingHeadKey === gi + '-' + index;
    },
    startEditSide(index) {
      if (this.editingSideIndex !== -1 && this.editingSideIndex !== index) {
        this.endEditSide(this.editingSideIndex);
      }
      this.editingSideIndex = index;
      this.$nextTick(() => {
        const inputs = this.$refs['sideInput' + index];
        if (inputs) {
          const inputEl = Array.isArray(inputs) ? inputs[0] : inputs;
          if (inputEl && inputEl.$el) {
            inputEl.$el.querySelector('input').focus();
          }
        }
      });
    },
    endEditSide(index) {
      if (this.editingSideIndex === index) {
        this.editingSideIndex = -1;
        this.$forceUpdate();
      }
    },
    isEditingSide(index) {
      return this.editingSideIndex === index;
    },
    cancelEdit() {
      if (this.editingHeadKey !== '' || this.editingSideIndex !== -1) {
        this.editingHeadKey = '';
        this.editingSideIndex = -1;
        this.$forceUpdate();
      }
    },
    getThumbnail(label) {
      return require(`@/assets/multi/multi-${label}.png`);
    },
    showImage(label) {
      this.currentImage = require(`@/assets/multi/multi-${label}.png`);
      this.imageDialogVisible = true;
    },
    getQid() {
      var api = this.COMMON.httpUrl + "qidSelect";
      var data = {
        pid: this.pid,
        kid: this.kid,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.configs = rs.data.cfg;
          let dt = rs.data.qids;
          let dd = [];
          for (let key of dt) {
            dd.push({ value: key.Qid, label: key.Qid+" "+key.Qlabel });
            this.qidcode[key.Qid] = key;
          }
          this.options = dd;
          this.optionsFil = dd;
          this.brandOptions = rs.data.brand_qids || [];
        }
      });
    },
    selectAll() {
      this.valueQid = [];
      for (let v1 of this.optionsFil) {
        this.valueQid.push([v1.value]);
      }
    },
    add2() {
      alert(this.wei)
    },
    add() {
      if (this.valueQid.length == 0) {
        alert("请至少选取一个题目");
        return;
      }

      if (this.valueQid.length >= 2) {
        const allMulti = this.valueQid.every(qid => this.qidcode[qid].Tpe === 'multi');
        if (!allMulti) {
          alert('只有不同qid的多选题才可以同时勾选多个选项');
          return;
        }
      }
     
      let cfg = {};
      cfg["qid"] = this.valueQid.join(",");
      cfg["tpe"] = this.qidcode[this.valueQid[0]].Tpe;
      cfg["wei"] = this.wei;
      cfg["pid"] = this.pid;
      cfg["kid"] = this.kid;
      this.save(cfg);
    },
    save(cfg) {
      this.loading = true;
      var api = this.COMMON.httpUrl + "kpiZuheSave";
      var data = {
        kid: this.kid,
        pid: this.pid,
        cfg: cfg,
      };
      this.axios.post(api, data).then((response) => {
        this.loading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message);
          this.configs = rs.data;
          this.$refs.cascaderPanel.clearCheckedNodes()
          this.keyword = "";
          this.wei ="1";
          this.weiShow=false;
        }
      });
    },
    tagDel(index, id) {
      var api = this.COMMON.httpUrl + "kpiZuheDel";
      var data = {
        kid: this.kid,
        id: id,
      };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.configs.splice(index, 1);
          this.$message.success(rs.message);
        }
      });
    },
    clearAll() {
      this.$confirm("确定清除全部已创建的组合表？此操作不可恢复。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.clearLoading = true;
        var api = this.COMMON.httpUrl + "kpiZuheClear";
        var data = { kid: this.kid };
        this.axios.post(api, data).then((response) => {
          this.clearLoading = false;
          var rs = response.data;
          if (rs.code) {
            this.$message.error(rs.message);
          } else {
            this.configs = [];
            this.$message.success(rs.message);
          }
        }).catch(() => {
          this.clearLoading = false;
        });
      }).catch(() => {});
    },
    preview(row) {
      try {
        const heads = typeof row.heads === 'string' ? JSON.parse(row.heads) : (row.heads || []);
        this.previewSides = typeof row.sides === 'string' ? JSON.parse(row.sides) : row.sides;
        this.previewRow = row;
        this.previewTpe = row.tpe;
        this.editingHeadKey = '';
        this.editingSideIndex = -1;
        if (row.tpe === 'grid') {
          // grid：按Lph分组，一个loop一个table（buildGroups内实现）
          this.previewGroups = this.buildGroups(heads);
        } else {
          // 非grid：单组平铺，行为与原版一致
          this.previewGroups = [{ lph: '', heads: heads }];
        }
        // grid品牌匹配：仅loop型grid回显已关联的品牌题并加载品牌名（非loop的grid不显示下拉）
        this.brandQid = (this.isLoopGrid && row.brand_qid) ? row.brand_qid : '';
        this.brandMap = {};
        if (this.brandQid) {
          this.fetchBrandOptions(this.brandQid);
        }
        // 记录打开时的快照与初始数据，用于脏检测和重置
        this.previewInitial = {
          heads: JSON.parse(JSON.stringify(heads)),
          sides: JSON.parse(JSON.stringify(this.previewSides)),
          brandQid: this.brandQid,
        };
        this.previewSnapshot = this.buildSnapshot();
        this.activeGi = 0;
        this.previewDialogVisible = true;
        this.$nextTick(() => {
          this.initRowSortables();
          this.initColSortables();
        });
      } catch (e) {
        this.$message.error('预览数据解析失败');
      }
    },
    destroyRowSortables() {
      this.rowSortables.forEach(s => s.destroy());
      this.rowSortables = [];
    },
    destroyColSortables() {
      this.colSortables.forEach(s => s.destroy());
      this.colSortables = [];
    },
    initRowSortables() {
      this.destroyRowSortables();
      const tbodys = this.$refs.previewTbody;
      if (!tbodys) return;
      const list = Array.isArray(tbodys) ? tbodys : [tbodys];
      list.forEach((tbody) => {
        const s = Sortable.create(tbody, {
          animation: 200,
          handle: '.drag-handle',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          onEnd: (evt) => {
            if (evt.oldIndex === evt.newIndex) return;
            const parent = evt.from;
            parent.removeChild(evt.item);
            const ref = parent.children[evt.oldIndex] || null;
            parent.insertBefore(evt.item, ref);
            const item = this.previewSides.splice(evt.oldIndex, 1)[0];
            this.previewSides.splice(evt.newIndex, 0, item);
          },
        });
        this.rowSortables.push(s);
      });
    },
    initColSortables() {
      this.destroyColSortables();
      const headerRows = this.$refs.headerLabelRow;
      if (!headerRows) return;
      const list = Array.isArray(headerRows) ? headerRows : [headerRows];
      const fixedCount = 2;
      list.forEach((headerRow, gi) => {
        const s = Sortable.create(headerRow, {
          draggable: '.drag-col',
          handle: '.drag-handle',
          animation: 200,
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          onEnd: (evt) => {
            const realOld = evt.oldIndex - fixedCount;
            const realNew = evt.newIndex - fixedCount;
            if (realOld === realNew || realOld < 0 || realNew < 0) return;
            const parent = evt.from;
            parent.removeChild(evt.item);
            const ref = parent.children[evt.oldIndex] || null;
            parent.insertBefore(evt.item, ref);
            const item = this.previewGroups[gi].heads.splice(realOld, 1)[0];
            this.previewGroups[gi].heads.splice(realNew, 0, item);
          },
        });
        this.colSortables.push(s);
      });
    },
    delCol(gi, index) {
      const group = this.previewGroups[gi];
      if (group.heads.length <= 1) {
        // grid下删掉某组最后一列 = 删除该loop表（后端len(loopHeads)==0会自动跳过）
        if (this.previewTpe === 'grid' && this.previewGroups.length > 1) {
          this.previewGroups.splice(gi, 1);
          // 组移除后ref数组变化，重新绑定sortable
          this.$nextTick(() => {
            this.initRowSortables();
            this.initColSortables();
          });
          return;
        }
        this.$message.warning('至少保留一列');
        return;
      }
      group.heads.splice(index, 1);
    },
    delRow(index) {
      if (this.previewSides.length <= 1) {
        this.$message.warning('至少保留一行');
        return;
      }
      this.previewSides.splice(index, 1);
    },
    // 品牌匹配：拉取品牌题选项，构建 code→品牌名 映射
    fetchBrandOptions(qid) {
      this.brandLoading = true;
      var api = this.COMMON.httpUrl + "qidOptions";
      var data = { pid: this.pid, qid: qid };
      this.axios.post(api, data).then((response) => {
        this.brandLoading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
          this.brandMap = {};
          return;
        }
        const map = {};
        for (const opt of rs.data.options || []) {
          map[String(opt.code)] = opt.label;
        }
        this.brandMap = map;
      }).catch(() => {
        this.brandLoading = false;
      });
    },
    onBrandChange(q) {
      if (q) {
        this.fetchBrandOptions(q);
      } else {
        this.brandMap = {};
      }
    },
    // loop标题后缀：匹配到品牌返回" · 品牌名"，选了品牌题但未匹配返回" · (未匹配)"
    loopBrandText(lph) {
      if (!this.brandQid) return '';
      if (this.brandMap[lph] !== undefined) return ' · ' + this.brandMap[lph];
      return ' · (未匹配)';
    },
    // 按题型构建预览分组：grid按Lph分组(一个loop一个table，数值升序、无Lph最后)，其余单组
    buildGroups(heads) {
      if (this.previewTpe === 'grid') {
        const groupMap = {};
        const lphOrder = [];
        for (const h of heads) {
          const lp = (h.Lph === undefined || h.Lph === null) ? '' : String(h.Lph);
          if (!groupMap[lp]) {
            groupMap[lp] = [];
            lphOrder.push(lp);
          }
          groupMap[lp].push(h);
        }
        lphOrder.sort((a, b) => {
          if (a === '') return 1;
          if (b === '') return -1;
          return Number(a) - Number(b);
        });
        return lphOrder.map(lp => ({ lph: lp, heads: groupMap[lp] }));
      }
      return [{ lph: '', heads: heads }];
    },
    // 当前状态快照（列顺序+行顺序+品牌关联），用于脏检测
    buildSnapshot() {
      let heads = [];
      for (const g of this.previewGroups) {
        heads = heads.concat(g.heads);
      }
      return JSON.stringify({
        h: heads,
        s: this.previewSides,
        b: this.isLoopGrid ? (this.brandQid || '') : '',
      });
    },
    // 快速导航chip文本：L{loop号}，匹配到品牌时附加品牌名(截断)
    quickChipText(g) {
      const lp = g.lph === '' ? '?' : g.lph;
      if (!this.brandQid) return 'L' + lp;
      const b = this.brandMap[g.lph];
      if (!b) return 'L' + lp;
      return 'L' + lp + ' ' + (b.length > 8 ? b.slice(0, 8) + '…' : b);
    },
    scrollToGroup(gi) {
      const els = this.$refs.previewGroupEl;
      const list = Array.isArray(els) ? els : [els];
      const wrap = this.$refs.previewWrap;
      if (!list || !list[gi] || !wrap) return;
      this.activeGi = gi;
      wrap.scrollTo({ top: list[gi].offsetTop - 8, behavior: 'smooth' });
    },
    // 滚动时节流计算当前激活的loop组
    onWrapScroll() {
      if (this.scrollTimer) return;
      this.scrollTimer = setTimeout(() => {
        this.scrollTimer = null;
        const wrap = this.$refs.previewWrap;
        const els = this.$refs.previewGroupEl;
        if (!wrap || !els) return;
        const list = Array.isArray(els) ? els : [els];
        let active = 0;
        for (let i = 0; i < list.length; i++) {
          if (list[i].offsetTop - wrap.scrollTop <= 60) active = i;
        }
        this.activeGi = active;
      }, 150);
    },
    // 关闭前脏检查：有未保存修改时二次确认
    handlePreviewClose(done) {
      if (this.isDirty) {
        this.$confirm('当前有未保存的修改，确定关闭预览？', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '继续编辑',
          type: 'warning',
        }).then(() => { done(); }).catch(() => {});
      } else {
        done();
      }
    },
    // 重置为打开预览时的状态
    resetPreview() {
      if (!this.previewInitial) return;
      const init = this.previewInitial;
      this.previewSides = JSON.parse(JSON.stringify(init.sides));
      this.brandQid = init.brandQid;
      this.brandMap = {};
      if (this.brandQid) {
        this.fetchBrandOptions(this.brandQid);
      }
      this.previewGroups = this.buildGroups(JSON.parse(JSON.stringify(init.heads)));
      this.editingHeadKey = '';
      this.editingSideIndex = -1;
      this.activeGi = 0;
      this.$nextTick(() => {
        this.initRowSortables();
        this.initColSortables();
      });
    },
    savePreview() {
      // 按组顺序拼接所有loop表的列
      let heads = [];
      for (const g of this.previewGroups) {
        heads = heads.concat(g.heads);
      }
      if (heads.length === 0) {
        this.$message.warning('至少保留一个loop表的列');
        return;
      }
      this.saveLoading = true;
      var api = this.COMMON.httpUrl + "kpiZuheUpdate";
      var data = {
        pid: this.pid,
        kid: this.kid,
        id: this.previewRow.id,
        heads: JSON.stringify(heads),
        sides: JSON.stringify(this.previewSides),
        brandQid: this.isLoopGrid ? (this.brandQid || '') : '',
      };
      this.axios.post(api, data).then((response) => {
        this.saveLoading = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message || '保存成功');
          this.previewRow.heads = JSON.stringify(heads);
          this.previewRow.sides = JSON.stringify(this.previewSides);
          if (this.isLoopGrid) {
            this.previewRow.brand_qid = this.brandQid || '';
          }
          // 保存成功后刷新快照与初始数据，脏状态清零
          this.previewInitial = {
            heads: JSON.parse(JSON.stringify(heads)),
            sides: JSON.parse(JSON.stringify(this.previewSides)),
            brandQid: this.isLoopGrid ? (this.brandQid || '') : '',
          };
          this.previewSnapshot = this.buildSnapshot();
        }
      });
    },
  },
  created() {
    localStorage.setItem("kpitag","six")
    this.getQid();
  },
};
</script>
  <style scoped>
#content {
  background-color: white;
  padding-top: 40px;
  padding-left: 50px;
}
.dleft {
  width: 550px;
}
.anl {
  margin-bottom: 20px;
}
/* v-deep深度选择器 */
:deep(.el-cascader-menu__wrap) {
  height: 350px;
}
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.tags {
  border: 2px dashed #e0e5f0;
  width: 550px;
  height: 550px;
  margin-left: 0px;
  margin-top: 20px;
  padding: 10px;
  overflow: auto;
}

.tags span {
  margin-left: 10px;
  margin-top: 10px;
}
.weizhi{
margin-top:25px;
}
.weizhi p{
  font-size:14px;
  color:rgb(175, 175, 175);
  padding:15px 0;
}

.radio-with-image {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.radio-with-image .el-radio {
  margin-left: 10px; /* 图片在前，选项在后，所以使用左边距 */
  flex-shrink: 0; /* 防止radio被压缩 */
}

.thumbnail {
  width: 40px;
  height: 40px;
  object-fit: contain;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 2px;
  vertical-align: middle;
}

.thumbnail:hover {
  opacity: 0.8;
  border-color: #409eff;
}

/* 优化单选按钮内部元素对齐 */
.el-radio__input {
  margin-right: 8px;
}

.el-radio__label {
  padding-left: 5px;
  line-height: normal;
}

/* 优化缩略图边距和视觉效果 */
.thumbnail-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px; /* 图片在前，选项在后，所以使用右边距 */
}

.thumbnail {
  transition: all 0.3s ease;
  box-sizing: border-box;
}

/* 改善选项之间的间距 */
.radio-with-image {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
}

/* 优化带边框的 radio 样式 */
.el-radio.border {
  padding: 10px 15px;
  border-radius: 4px;
  min-height: 40px;
}

.dright {
  width: 650px;
}

:deep(.el-table .el-table__body-wrapper) {
  max-height: 550px;
  overflow-y: auto;
}

:deep(.el-table) {
  font-size: 13px;
}

:deep(.el-table th.el-table__cell) {
  background-color: #f5f7fa;
}

/* ========== 预览弹窗 ========== */
:deep(.el-dialog__body) {
  min-height: 60vh;
  padding: 16px 20px;
}

.preview-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-left {
  font-size: 12px;
}

.dirty-hint {
  color: #e6a23c;
}

.clean-hint {
  color: #909399;
}

.footer-right {
  display: flex;
  align-items: center;
}

/* 弹窗标题栏：标题 + qid/题型标签 + 统计 */
.dlg-title-bar {
  display: flex;
  align-items: center;
}

.dlg-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-right: 10px;
}

.dlg-title-bar .el-tag {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dlg-stats {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}

/* 预览工具栏（品牌匹配） */
.preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0 10px;
}

.tb-left {
  display: flex;
  align-items: center;
}

.brand-label {
  font-size: 13px;
  color: #606266;
  margin-right: 8px;
  white-space: nowrap;
}

.tb-help {
  color: #909399;
  font-size: 15px;
  margin-left: 6px;
  cursor: help;
}

/* loop快速导航chips */
.loop-quicknav {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  padding: 0 0 10px;
}

.qn-chip {
  flex-shrink: 0;
  font-size: 12px;
  color: #606266;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  padding: 2px 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}

.qn-chip:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background: #ecf5ff;
}

.qn-chip.active {
  color: #fff;
  background: #409eff;
  border-color: #409eff;
}

/* 空状态 */
.preview-empty {
  padding: 30px 0;
}

.preview-table-wrap {
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.preview-table-center {
  min-width: 100%;
}

/* loop分组容器与标题 */
.preview-group {
  margin-bottom: 24px;
  scroll-margin-top: 8px;
}

.preview-group:last-child {
  margin-bottom: 0;
}

.group-title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2d3d;
  background-color: #f5f7fa;
  border-left: 3px solid #409eff;
  padding: 6px 10px;
  margin-bottom: 8px;
  display: inline-block;
}

.preview-table {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
  border: 1px solid #d8dce5;
  border-radius: 4px;
  min-width: 100%;
}

.preview-table th,
.preview-table td {
  border: 1px solid #dcdfe6;
  text-align: center;
  color: #303133;
  white-space: nowrap;
}

/* 粘性表头：长滚动时当前loop表的表头保持可见（第一行高40px，第二行紧贴其下） */
.preview-table thead th {
  position: sticky;
  z-index: 5;
}

.preview-table thead tr:first-child th {
  top: 0;
  height: 40px;
}

.preview-table thead tr:nth-child(2) th {
  top: 40px;
}

/* 固定左侧两列（Label/Code）：横向滚动时吸附左侧，宽度固定保证吸附偏移确定 */
.preview-table .side-header {
  position: sticky;
  background-color: #ebeef5;
  color: #1f2d3d;
  font-weight: 600;
  padding: 10px 14px;
}

.preview-table thead tr:first-child .side-header:nth-child(1) {
  left: 0;
  z-index: 7;
  width: 180px;
  min-width: 180px;
  max-width: 180px;
}

.preview-table thead tr:first-child .side-header:nth-child(2) {
  left: 180px;
  z-index: 7;
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

/* 数据列 */
.preview-table .data-col {
  max-width: 110px;
  min-width: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 列表头第一行（Label + 操作） */
.preview-table .drag-col {
  background-color: #ebeef5;
  padding: 0;
  position: relative;
  transition: background-color 0.2s;
}

.preview-table .drag-col:hover {
  background-color: #d9ecff;
}

.preview-table .drag-col:hover .col-del {
  opacity: 1;
}

.col-header-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 10px 10px 6px;
}

.col-content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  color: #1f2d3d;
  cursor: text;
}

.col-content:hover {
  background-color: #f5f7fa;
  border-radius: 2px;
}

/* 列表头第二行（Code） */
.preview-table .code-row {
  background-color: #f2f3f5;
  font-weight: 500;
  font-size: 12px;
  color: #48576a;
  padding: 6px 8px;
}

/* 数据行 */
.preview-table .data-row {
  transition: background-color 0.15s;
}

.preview-table .data-row:hover {
  background-color: #f5f7fa;
}

.preview-table .data-row:nth-child(even) {
  background-color: #fafbfc;
}

.preview-table .data-row:nth-child(even):hover {
  background-color: #f0f2f5;
}

/* 行左侧 Label 单元格（吸附左侧，宽度与表头Label列一致） */
.side-cell {
  background-color: #ebeef5;
  padding: 0;
  font-weight: 500;
  color: #1f2d3d;
  position: sticky;
  left: 0;
  z-index: 3;
  width: 180px;
  min-width: 180px;
  max-width: 180px;
  overflow: hidden;
}

.side-cell:hover .row-del {
  opacity: 1;
}

.row-cell-inner {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 8px 10px 8px 8px;
}

.row-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: text;
}

.row-label:hover {
  background-color: #f5f7fa;
  border-radius: 2px;
}

/* 行左侧 Code 单元格（吸附左侧，偏移=Label列宽） */
.side-code-cell {
  background-color: #f2f3f5;
  font-size: 12px;
  color: #48576a;
  font-weight: 500;
  padding: 8px 10px;
  position: sticky;
  left: 180px;
  z-index: 3;
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 数据区空单元格 */
.data-cell {
  padding: 8px 10px;
  min-height: 32px;
}

/* ========== 拖拽手柄 ========== */
.drag-handle {
  cursor: grab;
  color: #b0b3b8;
  font-size: 12px;
  flex-shrink: 0;
  transition: color 0.2s;
}

/* 编辑提示图标：hover时出现，提示文本可点击编辑 */
.edit-ico {
  flex-shrink: 0;
  font-size: 12px;
  color: #b0b3b8;
  opacity: 0;
  transition: opacity 0.15s;
}

.col-header-inner:hover .edit-ico,
.row-cell-inner:hover .edit-ico {
  opacity: 1;
}

.drag-handle:hover {
  color: #e6a23c;
}

.drag-handle:active {
  cursor: grabbing;
  color: #c78c30;
}

/* ========== 删除按钮 ========== */
.col-del {
  position: absolute;
  top: 1px;
  right: 1px;
  cursor: pointer;
  color: #fff;
  font-size: 11px;
  background: #c0c4cc;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  opacity: 0;
  transition: all 0.2s;
  z-index: 1;
}

.col-del:hover {
  background: #f56c6c;
  transform: scale(1.15);
}

.row-del {
  position: absolute;
  top: 1px;
  right: 1px;
  cursor: pointer;
  color: #fff;
  font-size: 11px;
  background: #c0c4cc;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  opacity: 0;
  transition: all 0.2s;
  z-index: 1;
}

.row-del:hover {
  background: #f56c6c;
  transform: scale(1.15);
}

/* ========== Sortable 拖拽状态 ========== */
.sortable-ghost {
  background-color: #ecf5ff !important;
  opacity: 0.6;
}

.sortable-chosen {
  background-color: #d9ecff !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

/* 仅作用于表格内的编辑输入框（列头/行头），宽度跟随单元格，不影响品牌匹配下拉框 */
.col-header-inner :deep(.el-input__inner),
.row-cell-inner :deep(.el-input__inner) {
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  width: 100%;
}
:deep(.el-input__inner:focus) {
  border-color: #409eff;
}
/* 下拉框input右侧留出后缀图标（三角/清除按钮）空间，避免文字压住图标 */
.preview-toolbar .el-select :deep(.el-input__inner) {
  padding-right: 30px;
}
</style>

<!-- 预览弹窗骨架：全局样式（弹窗挂载于body，scoped无法作用），固定高度flex布局，footer始终钉在弹窗底部可见 -->
<style>
.zuhe-preview-dialog {
  display: flex;
  flex-direction: column;
  height: 92vh;
  margin-bottom: 0 !important;
}

.zuhe-preview-dialog .el-dialog__header {
  flex-shrink: 0;
  padding-bottom: 12px;
}

.zuhe-preview-dialog .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 8px;
}

.zuhe-preview-dialog .el-dialog__footer {
  flex-shrink: 0;
  border-top: 1px solid #ebeef5;
  padding: 12px 20px 14px;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
 